import React from 'react'
import { useQuery } from 'react-query'
import { RedocStandalone } from 'redoc'

import { skuit } from '../services/skuit'

export const ClientAPIDocs = () => {
  const { data, isLoading } = useQuery(['docs-schema'], () => skuit.docs.client())
  return <>{isLoading ? <div>Loading...</div> : <RedocStandalone spec={data} />}</>
}
